import LazyLoad from 'react-lazyload';
import GlobalStyles from '@mui/material/GlobalStyles';
import useAppState from '../../../common/state/appState';
import CarRecommendations from './CarRecommendations';
import { useUftVehicleDisplay } from '../utilities/uftVehicleDisplay';

export const CarRecommendationsLoader: React.FC = () => {
    const uftRecommendedVehiclesLoading = useAppState((state) => state.uftRecommendedVehiclesLoading);
    const uftRecommendedVehiclesLoaded = useAppState((state) => state.uftRecommendedVehiclesLoaded);
    const { remainingRecommendedVehicles } = useUftVehicleDisplay();

    if (uftRecommendedVehiclesLoaded && !uftRecommendedVehiclesLoading && remainingRecommendedVehicles.length === 0) {
        return <GlobalStyles styles={{ '#car-recommendations': { display: 'none !important' } }} />;
    }

    return (
        <LazyLoad offset={200}>
            <CarRecommendations carouselId="car-recommendations-carousel" />
        </LazyLoad>
    );
};

export default CarRecommendationsLoader;
